import { computed } from 'mobx';
import { IGridProps } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models';
import { IGridComponentReference } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models/IGridComponentReference';
import { IFundCardConfiguration } from '../models';
import { QueryStore } from '../../App/stores/QueryStore';
import { StoreBase } from '../../../common/StoreBase';
import { FundCardStoreBase } from '../../../common/FundCardStoreBase';
import { IQueryContext } from '../../../models/commonTypes';
import { StoreContext } from '../../../configuration/StoreContext';

export abstract class BaseCardStore extends StoreBase {
	static componentKey: 'fundCard' = 'fundCard';
	queryStore: QueryStore;

	constructor(storeContext: StoreContext) {
		super(storeContext);
		this.queryStore = new QueryStore(storeContext);
	}

	abstract loadQueryStoreContext(queryContext?: IQueryContext): void;
	abstract get stores(): { [prop: string]: FundCardStoreBase };
	abstract get components(): { [key: string]: IGridComponentReference; };

	@computed
	get configuration(): IFundCardConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(BaseCardStore.componentKey);
		}
	}

	@computed
	get gridProps(): IGridProps | undefined {
		const gridProps = this.configuration && this.configuration.gridProps;
		return gridProps;
	}
}